import VueRouter from "vue-router";

import Main from "@/layouts/main.vue"
import Error from "@/layouts/error.vue"
import Admin from "@/layouts/admin.vue"
import Shipper from "@/layouts/shipper.vue"
import Driver from "@/layouts/driver.vue"
import Transporter from "@/layouts/transporter.vue"
import Blank from "@/layouts/blank.vue"
import HandlerLayout from "@/layouts/handler.vue"
import HandlerRoutes from "@/router/handler/index"


import Login from "@/pages/Login.vue"
import ForgotPassword from "@/pages/ForgotPassword.vue"
import ForgotUsername from "@/pages/ForgotUsername.vue"
import verificationOtp from "@/pages/verification_otp/VerificationOtp.vue"
import SignUp from "@/pages/SignUp.vue"

import AdminRoutes from "@/router/admin/index"
import HelpRoutes from "@/router/help"
import ShipperRoutes from "@/router/customer/index"
import DriverRoutes from "@/router/driver/index"
import TransporterRoutes from "@/router/transporter/index"
import BidRoutes from "@/router/hsm/bid/index"
import verificationRoutes from "@/router/verificationOtp"
import CompanyRequest from "@/pages/CompanyRequest.vue";

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/app",
    },
    {
      path: "/app",
      name: "app",
      component: Main,
      children: [
        {
          path: "login",
          name: "app-login",
          component: Login,
        },
        {
          path: "forgot-password",
          name: "app-forgot-password",
          component: ForgotPassword,
        },
        {
          path: "forgot-username",
          name: "app-forgot-username",
          component: ForgotUsername,
        },
        {
          path: "signup",
          name: "app-signup",
          component: SignUp,
        },
        {
          path: "company-request",
          name: "app-company-request",
          component: CompanyRequest,
        },

        // The in-app User Manual renders as its own full-page shell, outside the
        // Admin layout (no app nav drawer / app bar), so it must sit here rather
        // than inside AdminRoutes.
        ...HelpRoutes,

        {
          path: "admin",
          name: "app-admin",
          component: Admin,
          children: AdminRoutes
        },
        {
          path: "customer",
          name: "app-customer",
          component: Shipper,
          children: ShipperRoutes
        },
        {
          path: "driver",
          name: "app-driver",
          component: Driver,
          children: DriverRoutes
        },
        {
          path: "transporter",
          name: "app-transporter",
          component: Transporter,
          children: TransporterRoutes
        },
        {
          path: "bid",
          name: "app-bid",
          component: Blank,
          children: BidRoutes
        },
        {
          path: "verification-otp",
          name: "app-verification-otp",
          component: verificationOtp,
          children: verificationRoutes
        },

      ],
    },
    {
      path: "/handler",
      component: HandlerLayout,
      children: HandlerRoutes,
      redirect: "/handler/login",
    },
    {
      path: "**",
      component: Error,
    }
  ],
});

export default router;